import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Indexed Universal Life Insurance',
  description: "Our flagship IUL life insurance policies combine permanent death benefit protection with powerful cash value accumulation tied to market index performance. Your indexed universal life cash value grows when markets rise, but you're protected from losses when they fall."
}, {
  title: 'Tax-Free Retirement Planning',
  description: 'We specialize in structuring IUL insurance for retirement income. Access your cash value tax-free through policy loans, creating a supplemental retirement income stream with no contribution limits or required minimum distributions.'
}, {
  title: 'Policy Design & Optimization',
  description: "Every indexed universal life policy we design is customized to maximize cash value growth while maintaining the death benefit protection your family needs. We'll help you find the best indexed universal life insurance for your specific situation."
}, {
  title: 'Ongoing Policy Reviews',
  description: 'Markets change, life changes. We provide annual reviews of your IUL insurance policy ensuring optimal performance aligned with your ever-evolving goals.'
}];
export function Services() {
  return <section id="services" className="py-20 md:py-28 bg-cream px-6" data-id="element-170">
      <div className="max-w-[1100px] mx-auto" data-id="element-171">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-172">
          <span className="text-copper font-bold text-sm tracking-wider uppercase mb-3 block" data-id="element-173">
            Services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-174">
            Specialized Indexed Universal Life Expertise
          </h2>
          <p className="text-charcoal text-lg leading-relaxed" data-id="element-175">
            From foundational coverage to advanced retirement income planning,
            our IUL services are designed to help you take advantage of
            market-linked growth while protecting your downside.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-176">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-soft border-t-4 border-copper hover:shadow-hover transition-all duration-300 group" data-id="element-177">
              <h3 className="text-xl font-bold text-forest mb-4 group-hover:text-copper transition-colors" data-id="element-178">
                {service.title}
              </h3>
              <p className="text-charcoal/80 leading-relaxed" data-id="element-179">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}